// https://scotch.io/tutorials/build-a-mobile-app-with-angular-2-and-ionic-2

import { Injectable } from '@angular/core';
/*
  Generated class for the Menu provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.


translateService.get('HELLO').subscribe(
  value => {
    // value is our translated string
    let alertTitle = value;
  }
)
*/
@Injectable()
export class MenuService {
  constructor() {}

  // Should be an API call
  getAll() {
    return [

      {
        name: "e-store",
        id: 666,
        items: []// Required: array, even empty
      },
      
      {
        name: "active tailoring",
        id: 1543,
        story: 1543,
        items: [// Required: array, even empty
          {
            name: "concept",
            slug: 'concept',
            id: 1234,
            story: 1543,
            index: 0,
            items: []
          },
          {
            name: "savoir-faire",
            slug: 'savoir-faire',
            id: 1297, 
            story: 1543,
            index: 1,
            items: []
          },
          {
            name: "innovation",
            slug: 'innovation',
            id: 1338,
            story: 1543,
            index: 2,
            items: []
          },
        ]
      },
      
      /*{
        name: "vestiaire",
        id: 10,
        items: []
      },
      {
        name: "sacs",
        id: 2,
        story: 2,
        items: [
          
          {
            name: "concept",
            id: 1834,
            story: 2,
            //slug: 'soon',
            items: []
          },
          {
            name: "produits",
            id: 1223,
            story: 2,
            //slug: 'soon',
            items: []
          }

        ]
      },
      {
        name: "solaires",
        id: 40000,
        items: []
      },
      {
        name: "lookbook",
        id: 1553,
        story: 1553,
        items: [
          {
            name: "automne/hiver 2018-19",
            id: 1825,
            story: 1553,
            slug: 'collection-automne-hiver',
            index: 0,
            //icon: 'brush',
            items: []// Required: array, even empty
          },
          {
            name: "printemps/été 2018",
            id: 1555,
            story: 1553,
            slug: 'printemps-ete',
            index: 1,
            //icon: 'brush',
            items: []// Required: array, even empty
          }
          
        ]
      },
          */

      {
        name: "actualités",
        id: 1361,
        items: []// Required: array, even empty
      },
      {
        name: "nos services",
        id: 1544,
        story: 1544,
        items: [// Required: array, even empty
          {
            name: "demi-mesure",
            id: 1376,
            story: 1544,
            slug: 'demi-mesure',
            index: 0,
            //icon: 'bowtie',
            items: []
          },
          {
            name: "home shopping",
            id: 1430,
            story: 1544,
            slug: 'home-shopping',
            index: 1,
            //icon: 'basketball',
            items: []
          },
          {
            name: "carte cadeau",
            id: 1434,
            story: 1544,
            slug: 'carte-cadeau',
            index: 2,
            //icon: 'brush',
            items: []// Required: array, even empty
          }        
        ]
      },
      {
        name: "boutiques",
        id: 1545,
        story: 1545,
        items: [// Required: array, even empty
          {
            name: "Paris 3<sup>e</sup>",
            id: 1372,
            story: 1545,
            slug: 'paris-3e',
            index: 1,
            //icon: 'bowtie',
            items: []
          },
          {
            name: "New York",
            id: 1370,
            story: 1545,
            slug: 'new-york',
            index: 3,
            //icon: 'brush',
            items: []// Required: array, even empty
          }
        ]
      },
      




    ];
  }




 // <div class="shop-div">Le Bon Marché, Paris 7<sup>e</sup></div>

 getAll2() {
    return [
      {
        name: "e-store",
        id: 666,
        items: []// Required: array, even empty
      },
      {
        name: "active tailoring",
        id: 1543,
        story: 1543,
        items: [// Required: array, even empty
          {
            name: "concept",
            slug: 'concept',
            id: 1234,
            story: 1543,
            index: 0,
            items: []
          },
          {
            name: "know-how",
            slug: 'savoir-faire',
            id: 1297, 
            story: 1543,
            index: 1,
            items: []
          },
          {
            name: "innovation",
            slug: 'innovation',
            id: 1338,
            story: 1543,
            index: 2,
            items: []
          },
        ]
      },
      
      /*{
        name: "jackets / coats",
        id: 10,
        items: []
      },
      {
        name: "bags",
        id: 2,
        story: 2,
        items: [
          
          {
            name: "concept",
            id: 1834,
            story: 2,
            //slug: 'soon',
            items: []
          },

          {
            name: "products",
            id: 1223,
            story: 2,
            //slug: 'soon',
            items: []
          }

        ]
      },
      
      {
        name: "sunglasses",
        id: 40000,
        items: [],
      },
      {
        name: "sneakers",
        id: 10000,
        items: []
      },
      {
        name: "lookbook",
        id: 1553,
        story: 1553,
        items: [
          {
            name: "autumn/winter 2018-19",
            id: 1825,
            story: 1553,
            slug: 'collection-automne-hiver',
            index: 0,
            //icon: 'brush',
            items: []// Required: array, even empty
          },
          {
            name: "spring/summer 2018",
            id: 1555,
            story: 1553,
            slug: 'printemps-ete',
            index: 1,
            //icon: 'brush',
            items: []// Required: array, even empty
          }
          
          
          
        ]
      },*/
      {
        name: "news",
        id: 1361,
        items: []// Required: array, even empty
      },
      {
        name: "our services",
        id: 1544,
        story: 1544,
        items: [// Required: array, even empty
          {
            name: "made-to-measure",
            id: 1376,
            story: 1544,
            slug: 'demi-mesure',
            index: 0,
            //icon: 'bowtie',
            items: []
          },
          {
            name: "home shopping",
            id: 1430,
            story: 1544,
            slug: 'home-shopping',
            index: 1,
            //icon: 'basketball',
            items: []
          },
          {
            name: "gift card",
            id: 1434,
            story: 1544,
            slug: 'carte-cadeau',
            index: 2,
            //icon: 'brush',
            items: []// Required: array, even empty
          }
        ]
      },
      {
        name: "shops",
        id: 1545,
        story: 1545,
        items: [// Required: array, even empty
          
          {
            name: "Paris 3<sup>e</sup>",
            id: 1372,
            story: 1545,
            slug: 'paris-3e',
            index: 1,
            //icon: 'bowtie',
            items: []
          },
          {
            name: "New York",
            id: 1370,
            story: 1545,
            slug: 'new-york',
            index: 3,
            //icon: 'brush',
            items: []// Required: array, even empty
          }
        ]
      },
      


    ];
  }













  getAware() {
    return [
      {
        name: "enquêtes",
        id: 'coverage',
        slug: "benhen",
        items: []
      },
      {
        name: "zapping tv",
        id: 'coverage',
        slug: "vu",
        items: []
      },
      {
        name: "médias",
        id: 1553,
        story: 1553,
        items: [
          {
            name: "tv",
            id: 'list',
            story: 1553,
            slug: 'soon',
            index: 0,
            //icon: 'brush',
            items: []// Required: array, even empty
          },
          {
            name: "web",
            id: 'list',
            story: 1553,
            slug: 'soon',
            index: 1,
            //icon: 'brush',
            items: []// Required: array, even empty
          },
          {
            name: "presses",
            id: 'list',
            story: 1553,
            slug: 'soon',
            index: 1,
            //icon: 'brush',
            items: []// Required: array, even empty
          }
          /*,
          {
            name: "SS16",
            id: 1554,
            story: 1553,
            slug: 'soon',
            index: 2,
            //icon: 'brush',
            items: []// Required: array, even empty
          }*/
        ]
      },
      {
        name: "geek",
        id: 10,
        items: []
      }, 
      {
        name: "futur",
        id: 1543,
        story: 1543,
        items: [// Required: array, even empty
          {
            name: "monde",
            slug: 'active-tailoting-concept',
            id: 1234,
            story: 1543,
            index: 0,
            items: []
          },
          {
            name: "connecté",
            slug: 'active-tailoting-savoir-faire',
            id: 1297, 
            story: 1543,
            index: 1,
            items: []
          },
          {
            name: "innovation",
            slug: 'innovation',
            id: 1338,
            story: 1543,
            index: 2,
            items: []
          },
        ]
      },
      
      {
        name: "victoire",
        id: 'lazy',
        lazy: 'VictoireTabs',
        //story: 'victoire',
        items: []
      },
      
      {
        name: "coupe du monde",
        id: 1544,
        story: 1544,
        items: [// Required: array, even empty
          {
            name: "france",
            id: 'tree',
            story: 1544,
            slug: 'soon',
            index: 0,
            //icon: 'basketball',
            items: []
          },
          {
            name: "joueurs",
            id: 'list',
            story: 1544,
            slug: 'soon',
            index: 1,
            //icon: 'bowtie',
            items: []
          },
          {
            name: "matchs",
            id: 'class',
            story: 1544,
            slug: 'soon',
            index: 2,
            //icon: 'brush',
            items: []// Required: array, even empty
          }
        ]
      },
      {
        name: "divertissements",
        id: 1545,
        story: 1545,
        items: [// Required: array, even empty
          {
            name: "humour",
            id: 'list',
            story: 1545,
            slug: 'soon',
            index: 2,
            //icon: 'brush',
            items: []// Required: array, even empty
          },
          {
            name: "cinéma",
            id: 'search',
            story: 1545,
            slug: 'soon',
            index: 0,
            //icon: 'basketball',
            items: []
          },
          {
            name: "musique",
            id: 1430,
            story: 1545,
            slug: 'soon',
            index: 0,
            //icon: 'basketball',
            items: []
          },
          {
            name: "jeux vidéos",
            id: 1376,
            story: 1545,
            slug: 'soon',
            index: 1,
            //icon: 'bowtie',
            items: []
          },
          
        ]
      }




    ];
  }

  getCDM() {
    return [
      {
        name: "top 100",
        id: 'list',
        story: 1000,
        //icon: 'bowtie',
        items: [
          {
            name: "joueurs",
            id: 'list',
            story: 1000,
            slug: 'soon',
            index: 0,
            //icon: 'bowtie',
            items: []
          },
          {
            name: "clubs",
            id: 'list',
            story: 1000,
            slug: 'soon',
            index: 1,
            //icon: 'bowtie',
            items: []
          },
          {
            name: "nations",
            id: 'list',
            story: 1000,
            slug: 'soon',
            index: 2,
            //icon: 'bowtie',
            items: []
          }
        ]
      },
      
      {
        name: "médias",
        id: 1553,
        story: 1553,
        items: [
          {
            name: "tv",
            id: 'list',
            story: 1553,
            slug: 'soon',
            index: 0,
            //icon: 'brush',
            items: []// Required: array, even empty
          },
          {
            name: "web",
            id: 'list',
            story: 1553,
            slug: 'soon',
            index: 1,
            //icon: 'brush',
            items: []// Required: array, even empty
          },
          {
            name: "presses",
            id: 'list',
            story: 1553,
            slug: 'soon',
            index: 1,
            //icon: 'brush',
            items: []// Required: array, even empty
          }
          /*,
          {
            name: "SS16",
            id: 1554,
            story: 1553,
            slug: 'soon',
            index: 2,
            //icon: 'brush',
            items: []// Required: array, even empty
          }*/
        ]
      },
      {
        name: "CDM 2018",
        id: 1544,
        story: 1544,
        items: [// Required: array, even empty
          {
            name: "france",
            id: 'tree',
            story: 1544,
            slug: 'soon',
            index: 0,
            //icon: 'basketball',
            items: []
          },
          {
            name: "joueurs",
            id: 'list',
            story: 1544,
            slug: 'soon',
            index: 1,
            //icon: 'bowtie',
            items: []
          },
          {
            name: "classement",
            id: 'class',
            story: 1544,
            slug: 'soon',
            index: 2,
            //icon: 'brush',
            items: []// Required: array, even empty
          }
        ]
      },
      {
        name: "Champions League",
        id: 1545,
        story: 1545,
        items: [// Required: array, even empty
          {
            name: "humour",
            id: 'list',
            story: 1545,
            slug: 'soon',
            index: 2,
            //icon: 'brush',
            items: []// Required: array, even empty
          },
          {
            name: "cinéma",
            id: 'search',
            story: 1545,
            slug: 'soon',
            index: 0,
            //icon: 'basketball',
            items: []
          },
          {
            name: "musique",
            id: 1430,
            story: 1545,
            slug: 'soon',
            index: 0,
            //icon: 'basketball',
            items: []
          },
          {
            name: "jeux vidéos",
            id: 1376,
            story: 1545,
            slug: 'soon',
            index: 1,
            //icon: 'bowtie',
            items: []
          },
          
        ]
      },
      {
        name: "e-sport",
        id: 10,
        items: []// Required: array, even empty
      },




    ];
  }


}





// WEBPACK FOOTER //
// ./src/components/multilevel-menu/menu.ts